module.exports = __webpack_public_path__ + "media/deep_space.6cd64604.wav";